import React from "react";
import PropTypes from "prop-types";
import AccordionTitle from "../../../components/molecules/accordion/accordionTitle";

/**
 * Higher-order component that wraps the AccordionTitle component.
 * It manages the active state of the accordion and applies the appropriate styles.
 * @param {Object} props - The component props.
 * @param {number} props.index - The index of the accordion section.
 * @param {JSX.Element} props.children - The content to be displayed inside the accordion.
 * @param {function} props.setActiveIndex - Function to set the active index of the accordion.
 * @param {number} props.activeIndex - The current active accordion index.
 * @returns {JSX.Element} The rendered AccordionTitleHOC component.
 */
const AccordionTitleHOC = ({ index, children, setActiveIndex, activeIndex }) => {
  return (
    <AccordionTitle
      styles="rounded-md flex justify-between bg-gray-100 p-8 md:p-3 lg:p-12 my-8"
      activeIndex={activeIndex}
      changeActiveIndex={setActiveIndex}
      index={index}
      inactiveClass="text-sm rounded-lg flex text-fnp-500 justify-between"
      activeClass="text-sm flex justify-between text-fnp-500 rounded-lg"
    >
      {children}
    </AccordionTitle>
  );
};

AccordionTitleHOC.propTypes = {
  index: PropTypes.number.isRequired,
  children: PropTypes.object.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
  activeIndex: PropTypes.number.isRequired,
};

export default AccordionTitleHOC;
